module.exports = __webpack_public_path__ + "img/floppy-disks.8edca2ec.svg";